/*!
 * 24/7 Customer, Inc. Confidential, Do Not Distribute. This is an
 * unpublished, proprietary work which is fully protected under
 * copyright law. This code may only be used pursuant to a valid
 * license from 24/7 Customer, Inc. http://www.247-inc.com
 */
window.SN=function(t){function n(){var t=document.location.protocol+"//d1af033869koo7.cloudfront.net/psp/platform/247px.js",n=document.createElement("script");n.async=!0,n.src=t;var e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)}return t.clientKey='columbia-v1-001',t.cdnRoot="d1af033869koo7.cloudfront.net",n(),t}(window.SN||{});
